// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.payment.CreatePaymentSubscriptionWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreatePaymentSubscriptionWebApiRequestDto } from '../..';

export const CreatePaymentSubscriptionWebApiHandler_createPaymentSubscription_Path =
  '/api/web/v1/payment/createPaymentSubscription';

/**
 * Create a renter payment subscription
 */
export const CreatePaymentSubscriptionWebApiHandler_createPaymentSubscription = (
  postData: CreatePaymentSubscriptionWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreatePaymentSubscriptionWebApiRequestDto, void>(
    {
      endpoint: CreatePaymentSubscriptionWebApiHandler_createPaymentSubscription_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
